<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let offer = data?.offer;
	let group = data?.group;
	let award = data?.award;

	const typeoffer: any = [
		{
			text: 'type_rooms',
			type: 'Rooms'
		},
		{
			text: 'type_fnb',
			type: 'Food & Beverage'
		},
		{
			text: 'type_spa',
			type: 'Spa'
		}
	];

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Offers - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="http://50.6.171.246:5000/offers" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="offers">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src="/img/bg-header-offer-new.webp"
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Special Offers</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 offers-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">
					{$_('offer_title_1')}
				</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica">
					{$_('offer_desc_1')}
				</p>
			</div>
		</div>
		<div class="container py-md-5 py-4 px-0">
			<ul
				class="nav nav-pills mb-3 justify-content-center px-3 px-md-0"
				id="pills-tab"
				role="tablist"
			>
				<li class="nav-item pb-2" role="presentation">
					<button
						class="nav-link active"
						id="pills-all-tab"
						data-bs-toggle="pill"
						data-bs-target="#pills-all"
						type="button"
						role="tab"
						aria-controls="pills-all"
						aria-selected="true">{$_('type_all')}</button
					>
				</li>
				{#each typeoffer as group, index}
					<li class="nav-item pb-2" role="presentation">
						<button
							class="nav-link"
							id="pills-{index}-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-{index}"
							type="button"
							role="tab"
							aria-controls="pills-{index}"
							aria-selected="false">{$_(`${group.text}`)}</button
						>
					</li>
				{/each}
			</ul>

			<div class="tab-content" id="pills-tabContent">
				<div
					class="tab-pane fade show active"
					id="pills-all"
					role="tabpanel"
					aria-labelledby="pills-all-tab"
					tabindex="0"
				>
					<div class="row g-0">
						{#each offer as offer}
							<div class="col-md-6 col-12 p-md-3 pb-3 px-3" id={offer.slug}>
								<div class="ratio ratio-4x3 d-none d-md-block position-relative">
									<img
										alt="Holiday Inn Resort Nusa Dua"
										src={offer.featured_images[0].path}
										class="w-100 h-100 object-fit-cover"
									/>
									<div class="text-offer text-white">
										<div>
											<p class="mb-md-3 fs-3 ff-lola-bir lh-1">{offer.name}</p>
											<p class="ff-helvetica mb-md-4"><small>{offer.excerpt}</small></p>
											<p class="mb-1">
												<a
													id="out_{offer.slug}"
													data-sveltekit-reload
													href={offer.book_url}
													target="_blank"
													class="btn btn-light btn-sm px-3 py-1 fw-medium ff-helvetica rounded-3 me-2"
													>{$_('btn_book_package')}</a
												>
												<a
													data-sveltekit-reload
													href="/{lang}/offers/{offer.slug}"
													class="btn btn-outline-light btn-sm rounded-3 px-3 py-1 ff-helvetica fw-medium"
													>{$_('btn_view_details')}</a
												>
											</p>
										</div>
									</div>
								</div>

								<div class="ratio ratio-1x1 d-block d-md-none position-relative">
									<img
										alt="Holiday Inn Resort Nusa Dua"
										src={offer.featured_images[0].path}
										class="w-100 h-100 object-fit-cover"
									/>
									<div class="text-offer text-white">
										<div>
											<p class="mb-md-3 mb-2 fs-3 ff-lola-bir lh-1">{offer.name}</p>
											<p class="ff-helvetica mb-md-4"><small>{offer.excerpt}</small></p>
											<p class="mb-1">
												<a
													id="out_{offer.slug}"
													data-sveltekit-reload
													href={offer.book_url}
													target="_blank"
													class="btn btn-light btn-sm px-3 py-1 fw-medium ff-helvetica rounded-3 me-2"
													>{$_('btn_book_package')}</a
												>
												<a
													data-sveltekit-reload
													href="/{lang}/offers/{offer.slug}"
													class="btn btn-outline-light btn-sm rounded-3 px-3 py-1 ff-helvetica fw-medium"
													>{$_('btn_view_details')}</a
												>
											</p>
										</div>
									</div>
								</div>
							</div>
						{/each}
					</div>
				</div>
				{#each typeoffer as group, index}
					<div
						class="tab-pane fade"
						id="pills-{index}"
						role="tabpanel"
						aria-labelledby="pills-{index}-tab"
						tabindex="0"
					>
						<div class="row g-0">
							{#each offer as offer}
								{#if offer.type == group.type}
									<div class="col-md-6 col-12 p-md-3 pb-3 px-3" id={offer.slug}>
										<div class="ratio ratio-4x3 d-none d-md-block position-relative">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src={offer.featured_images[0].path}
												class="w-100 h-100 object-fit-cover"
											/>
											<div class="text-offer text-white">
												<div>
													<p class="mb-md-3 fs-3 ff-lola-bir lh-1">{offer.name}</p>
													<p class="ff-helvetica mb-md-4"><small>{offer.excerpt}</small></p>
													<p class="mb-1">
														<a
															id="out_{offer.slug}"
															data-sveltekit-reload
															href={offer.book_url}
															target="_blank"
															class="btn btn-light btn-sm px-3 py-1 fw-medium ff-helvetica rounded-3 me-2"
															>{$_('btn_book_package')}</a
														>
														<a
															data-sveltekit-reload
															href="/{lang}/offers/{offer.slug}"
															class="btn btn-outline-light btn-sm rounded-3 px-3 py-1 ff-helvetica fw-medium"
															>{$_('btn_view_details')}</a
														>
													</p>
												</div>
											</div>
										</div>
										<div class="ratio ratio-1x1 d-block d-md-none position-relative">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src={offer.featured_images[0].path}
												class="w-100 h-100 object-fit-cover"
											/>
											<div class="text-offer text-white">
												<div>
													<p class="mb-md-3 mb-2 fs-3 ff-lola-bir lh-1">{offer.name}</p>
													<p class="ff-helvetica mb-md-4"><small>{offer.excerpt}</small></p>
													<p class="mb-1">
														<a
															id="out_{offer.slug}"
															data-sveltekit-reload
															href={offer.book_url}
															target="_blank"
															class="btn btn-light btn-sm px-3 py-1 fw-medium ff-helvetica rounded-3 me-2"
															>{$_('btn_book_package')}</a
														>
														<a
															data-sveltekit-reload
															href="/{lang}/offers/{offer.slug}"
															class="btn btn-outline-light btn-sm rounded-3 px-3 py-1 ff-helvetica fw-medium"
															>{$_('btn_view_details')}</a
														>
													</p>
												</div>
											</div>
										</div>
									</div>
								{/if}
							{/each}
						</div>
					</div>
				{/each}
			</div>
			{#each offer as offer}
				<div
					class="modal fade"
					id="detail-{offer.slug}"
					tabindex="-1"
					aria-labelledby="exampleModalLabel"
					aria-hidden="true"
				>
					<div class="modal-dialog modal-dialog-centered modal-lg">
						<div class="modal-content">
							<div class="modal-body">
								<div class="row g-0">
									<div class="col-md-12">
										<p class="text-end">
											<button
												type="button"
												class="btn-close"
												data-bs-dismiss="modal"
												aria-label="Close"
											></button>
										</p>
										<p class="main-color mb-md-2 mb-1 ff-lola-mr fs-5 lh-sm">{$_('offer_sub')}</p>
										<p class="main-color mb-md-4 mb-3 fs-1 ff-lola-bir lh-sm">{offer.name}</p>
										<div class="ff-helvetica mb-md-5 mb-3">
											{@html offer.description}
										</div>
										<p class="mb-0">
											<a
												id="in_{offer.slug}"
												href={offer.book_url}
												target="_blank"
												class="btn main-btn px-4 py-2 fw-medium ff-helvetica rounded-3 me-3"
												>{$_('btn_book_package')}</a
											>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.offers-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #757fbd;
		width: 25%;
	}
	.offers-welcome .text-offer {
		position: absolute;
		top: 0%;
		left: 0%;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: end;
		padding: 20px;
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
	}
	.offers-welcome .nav-pills .nav-link {
		color: #757fbd;
		border: 1px solid #757fbd;
		padding: 5px 20px;
		margin: 0 5px;
		border-radius: 10px;
	}
	.offers-welcome .nav-pills .nav-link.active {
		background-color: #757fbd;
		border: 1px solid #757fbd;
		color: white;
		padding: 5px 20px;
		border-radius: 10px;
	}
	@media (max-width: 600px) {
		.offers-welcome .text-offer {
			position: absolute;
			top: 0%;
			left: 0%;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: end;
			padding: 20px;
			background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
		}
	}
</style>
